import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Decadence} from "../Decadence";
import {DecadenceGameAssets} from "../DecadenceGameAssets";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {gsap} from "gsap"
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {DecadenceStatics} from "../config/DecadenceStatics";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class SkateOrDieTransitionScreenView extends PIXI.Container implements StageLayer {

    private bgDarken:PIXI.Sprite;
    private placeHolderText:PIXI.Text;

    private continueButtonCallback?:Function;
    private continueButton:ContinueButton;

    private bigWinAnimation:PIXI.spine.Spine;

    private fsIntroOutroAnim:PIXI.spine.Spine;
    private wincapAnimation:PIXI.spine.Spine;

    constructor() {
        super();
        this.name = "TransitionScreenView";


        // Bg darken
        this.bgDarken = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.bgDarken.tint = 0x000000;
        this.bgDarken.alpha = 0.7;
        this.bgDarken.visible = false;
        this.bgDarken.anchor.set(0.5, 0.5);
        this.bgDarken.position.set(360, 360);

        this.addChild(this.bgDarken);

        this.bigWinAnimation = DecadenceGameAssets.createSpine(DecadenceGameAssets.BIG_WIN_ANIMATION);
        this.bigWinAnimation.position.set(360, 360);
        this.bigWinAnimation.alpha = 0;
        this.addChild(this.bigWinAnimation);

        this.fsIntroOutroAnim = DecadenceGameAssets.createSpine(DecadenceGameAssets.FS_INTRO_OUTRO_ANIMATION);
        this.fsIntroOutroAnim.position.set(360, 360);
        this.fsIntroOutroAnim.alpha = 0;
        this.addChild(this.fsIntroOutroAnim);

        this.wincapAnimation = DecadenceGameAssets.createSpine(DecadenceGameAssets.WINCAP_ANIMATION);
        this.wincapAnimation.position.set(360, 360);
        this.wincapAnimation.alpha = 0;
        this.addChild(this.wincapAnimation);

        // Placeholder text
        const textStyle = new PIXI.TextStyle({
            fill: "#ffffff",
            fontFamily: "Helvetica",
            fontSize: 60,
            fontStyle: "oblique",
            fontWeight: "bolder",
            lineJoin: "round",
            stroke: "#ff0000",
            strokeThickness: 3,
            wordWrapWidth: 600,
            wordWrap: true,
            breakWords: true,
            align: "center",
            padding: 50
        });
        this.placeHolderText = new PIXI.Text("", textStyle);
        (<PIXI.Point>this.placeHolderText.anchor).set(0.5, 0.5);
        this.placeHolderText.position.set(360, 360);
        this.placeHolderText.alpha = 0;
        this.addChild(this.placeHolderText);

        // Continue Button
        this.continueButton = new ContinueButton();
        this.continueButton.addClickCallback(() => this.onButtonClick());
        this.continueButton.position.set(360, 610);
        this.continueButton.pivot.set(this.continueButton.width * 0.5, this.continueButton.height * 0.5);
        this.continueButton.enable(false);
        this.continueButton.alpha = 0;

        this.addChild(this.continueButton);

        this.onResize();
    }


    public hide(fadeDuration:number = 0.5):gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this, {alpha: 0, duration: fadeDuration}))
            .add(() => {
                this.bigWinAnimation.alpha = 0;
                this.placeHolderText.alpha = 0;
                this.fsIntroOutroAnim.alpha = 0;
                this.wincapAnimation.alpha = 0;
                this.bgDarken.alpha = 0;
                this.alpha = 1;
            })
    }

    public enableButton(cb:Function):gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.continueButtonCallback = cb;
                this.continueButton.enable(true);
            })
            .add(gsap.to(this.continueButton, {duration: 0.2, alpha: 1}))
    }

    public darken(fadeDur:number):gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.bgDarken.visible = true;
                this.bgDarken.alpha = 0;
            })
            .add(gsap.to(this.bgDarken, {alpha: 0.7, duration: fadeDur}))
    }

    public showWinCap():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.wincapAnimation.alpha = 1;
            })
            .add(SpineGSAPWrapper.createTimeline(this.wincapAnimation, 0, "intro"))
            .add(() => {
                this.wincapAnimation.state.setAnimation(0, "idle", true);
        })
    }

    public showFSIntro(isSuperFS:boolean):gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(() => {
            this.placeHolderText.text = `${Decadence.model.data.freespinsLeft}`+ "  " +Decadence.apiPlugin.translations.translate("SPINS");
            this.placeHolderText.position.set(360 + 533, 450);
            this.placeHolderText.style.fontSize = 55;
            this.placeHolderText.alpha = 0;
            this.fsIntroOutroAnim.alpha = 1;
            this.alpha = 1;
            this.placeHolderText.style.lineHeight = undefined;
        })
        const animName = isSuperFS ? "intro_sfs" : "intro";
        tl.add(SpineGSAPWrapper.createTimeline(this.fsIntroOutroAnim, 0, animName));
        tl.add(gsap.to(this.placeHolderText.position, {x: 360, ease: "back.out(1.7)", duration: 0.35}), ">-0.3")
        tl.add(gsap.to(this.placeHolderText, {alpha: 1, duration: 0.35, ease:"none"}), "<")
        return tl;
    }

    public showFSUpgrade(additionalSpins:number):gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(() => {
            this.placeHolderText.text = `${additionalSpins} ${Decadence.apiPlugin.translations.translate("Extra Spins Awarded")}`;
            this.placeHolderText.position.set(360 + 533, 520);
            this.placeHolderText.style.fontSize = 55;
            this.placeHolderText.alpha = 0;
            this.fsIntroOutroAnim.alpha = 1;
            this.alpha = 1;
        })
        tl.add(SpineGSAPWrapper.createTimeline(this.fsIntroOutroAnim, 0, "intro_sfs"));
        tl.add(gsap.to(this.placeHolderText.position, {x: 360, ease: "back.out(1.7)", duration: 0.35}), ">-0.3")
        tl.add(gsap.to(this.placeHolderText, {alpha: 1, duration: 0.35, ease:"none"}), "<")
        return tl;
    }

    public showFSRetrigger(additionalSpins:number):gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(() => {
            this.placeHolderText.text = `${additionalSpins} ${Decadence.apiPlugin.translations.translate("Extra Spins Awarded")}`;
            this.placeHolderText.position.set(360 + 533, 360);
            this.placeHolderText.style.fontSize = 55;
            this.placeHolderText.alpha = 0;
            this.fsIntroOutroAnim.alpha = 1;
            this.alpha = 1;
        })
        tl.add(SpineGSAPWrapper.createTimeline(this.fsIntroOutroAnim, 0, "outro"));
        tl.add(gsap.to(this.placeHolderText.position, {x: 360, ease: "back.out(1.7)", duration: 0.35}), ">-0.3")
        tl.add(gsap.to(this.placeHolderText, {alpha: 1, duration: 0.35, ease:"none"}), "<")
        return tl;
    }

    public showFSOutro():gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(() => {
            this.placeHolderText.text = `${Decadence.apiPlugin.translations.translate("SPINS PLAYED")}: ${Decadence.model.data.freespinsPlayed}`;
            if(!Decadence.model.winBelowStake) {
                this.placeHolderText.text += `\n${Decadence.apiPlugin.translations.translate("TOTAL WIN")}: ${SlotGame.apiPlugin.currency.formatValue(Decadence.model.accumulatedWin)}`;
            } else {
                this.placeHolderText.text += `\n ${SlotGame.apiPlugin.currency.formatValue(Decadence.model.accumulatedWin)}`;
            }
            this.placeHolderText.position.set(360 + 533, 360);
            this.placeHolderText.alpha = 0;
            this.fsIntroOutroAnim.alpha = 1;
            this.placeHolderText.style.lineHeight = 85;
        })
        tl.add(SpineGSAPWrapper.createTimeline(this.fsIntroOutroAnim, 0, "outro"));
        tl.add(gsap.to(this.placeHolderText.position, {x: 360, ease:"back.out(1.7)", duration: 0.35}), ">-0.4")
        tl.add(gsap.to(this.placeHolderText, {alpha: 1, duration: 0.35, ease:"none"}), "<")
        return tl;
    }

    public showBigWinIntro():gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(() => {
            this.alpha = 1;
            this.bigWinAnimation.alpha = 1;
        })
        tl.add(SpineGSAPWrapper.createTimeline(this.bigWinAnimation, 0, "bw1_intro"))
        tl.add(() => {
            this.bigWinAnimation.state.setAnimation(0, "bw1", true);
        })
        return tl;
    }

    public showWincap():gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(() => {
            this.bgDarken.visible = true;
        })
        tl.add(SpineGSAPWrapper.createTimeline(this.wincapAnimation, 0, "intro"));
        tl.add(() => {
            this.wincapAnimation.state.setAnimation(0, "idle", true);
        })
        return tl;
    }

    public startBigWinLevel(level:number):gsap.core.Timeline {
        const mixDuration = 0.25;
        return gsap.timeline()
            //.add(() => {
            //    this.bigWinAnimation.state.setAnimation(0, `bw${level}`, true);
            //})
            .add(SpineGSAPWrapper.createTimeline(this.bigWinAnimation, 0, `bw${level}`, mixDuration));
    }

    onResize() {
        if(NolimitApplication.isLandscape) {
            this.continueButton.position.set(360, 610);
        } else {
            this.continueButton.position.set(360, NolimitApplication.screenBounds.bottom - 170);
        }

        this.bgDarken.width = NolimitApplication.screenBounds.width;
        this.bgDarken.height = NolimitApplication.screenBounds.height;
    }

    private onButtonClick() {
        this.continueButton.enable(false);
        if(this.continueButtonCallback == undefined) {
            throw new Error("No ContinueButton Callback!");
        }
        this.continueButtonCallback();
        gsap.to(this.continueButton, {duration: 0.2, alpha: 0});
        delete this.continueButtonCallback;
    }
}